export const UPDATE_WISHLIST = /* GraphQL */ `
    mutation updateWishlist(
        $wishlistId: ID!
        $name: String
        $visibility: WishlistVisibilityEnum
    ) {
        updateWishlist(
            wishlistId: $wishlistId
            name: $name
            visibility: $visibility
        ) {
            uid
            name
            visibility
        }
    }
`
